<nz-modal
  nzWrapClassName=""
  [(nzVisible)]="isVisibleModal"
  [nzTitle]="modalTitle"
  [nzCentered]="true"
  [nzClassName]="'modal-m-t-30'"
  [nzContent]="modalContent"
  [nzFooter]="modalFooter"
  (nzOnCancel)="onClose()"
  [nzMaskStyle]="{'background': 'rgba(255, 255, 255, 0.69)'}">
  <ng-template #modalTitle>
  </ng-template>

  <ng-template #modalContent>
    <div class="d-flex justify-content-center align-items-center flex-column" *ngIf="optionCancel" @fadeInAnimation>
      <!-- una imagen cuando quieres bajar el plan y no se puede por exceder el num de recursos -->
      <img loading="lazy" src="./../../../assets/images/wait-2.jpg" alt="" style="height: 220px;">
      <p class="text-info mt-xlg text-center">
        ¡Cuidado! Estás a punto de cancelar la suscripción, una vez cancelada expertos y pacientes no podrán acceder a la plataforma.
      </p>
      <p class="text-info mt-xlg mb-xlg text-center">
        <i nz-icon nzType="hourglass" nzTheme="outline" class="mr-xxs"></i>Perderás el acceso a esta cuenta a partir del {{ (billingInfo$ |
        async)?.nextPayment?.date | date:'fullDate' }}
      </p>
      <div class="container-footer-modal d-flex justify-content-center mt-xlg">
        <button
          (click)="onClose()"
          class="mr-xs"
          nz-button nzType="primary" nzGhost>
          NO QUIERO</button>
        <button
          (click)="onSelectCancelPlan()"
          nz-button nzType="primary" nzDanger>
          SÍ QUIERO CANCELARLA
        </button>
      </div>
    </div>
    <div class="d-flex justify-content-center align-items-center flex-column" *ngIf="moreDays" @fadeInAnimation>
      <img loading="lazy" src="./../../../assets/images/sad-2.jpg" alt="" style="height: 220px;">
      <p class="text-info text-center mt-xlg">
        Tenemos una oferta especial para ti, si aceptas quedarte te regalaremos 15 días más totalmente gratis.
      </p>
      <div class="container-footer-modal d-flex justify-content-center mt-xlg">
        <button
          class="mr-xs"
          (click)="onSelectAcceptMoreDays(false)"
          nz-button nzType="primary" nzDanger>
          NO, CANCELAR CUENTA</button>
        <button
          (click)="onSelectAcceptMoreDays(true)"
          nz-button nzType="primary">
          SÍ, ACEPTAR LA PROMOCIÓN
        </button>
      </div>
    </div>
    <div class="d-flex justify-content-center align-items-center flex-column" *ngIf="reasonCancel" @fadeInAnimation>
      <div class="tw-w-full d-flex justify-content-center align-items-center flex-column" *ngIf="!moreDaysAccept">
        <img loading="lazy" src="./../../../assets/images/sad.jpg" alt="" style="height: 220px;">
        <p class="text-info mb-xxs">Al cancelar la suscripción tu acceso continuará hasta terminar el periodo el {{ (subscriptionActive$ |
          async)?.currentPeriodEnd | date:'fullDate' }}.</p>
        <div class="text-info mb-xs" style="position: relative; left: -57px;">
          <ul style="list-style: circle;">
            <li>Los expertos no podrán acceder</li>
            <li>Los pacientes no podrán acceder</li>
            <li>No se podrán registrar más expertos o pacientes</li>
          </ul>
        </div>
        <textarea rows="4" nz-input [(ngModel)]="reason" placeholder="Cuentanos por qué nos dejas"></textarea>
        <div class="container-footer-modal d-flex justify-content-center mt-xlg">
          <button nz-button class="tw-w-full btn-dangerous" (click)="onCancelSubscription()">
            <i nz-icon nzType="send" nzTheme="outline"></i>
            ENVIAR Y CANCELAR CUENTA</button>
        </div>
      </div>
      <div class="tw-w-full d-flex justify-content-center align-items-center flex-column" *ngIf="moreDaysAccept">
        <img loading="lazy" src="./../../../assets/images/congratulations.jpg" alt="" style="height: 220px;">
        <p class="text-title-lg mb-xlg">¡FELICIDADES!</p>
        <p class="text-info mb-xlg">Gracias por quedarte con nosotros, disfruta de tus 15 días extra.</p>
        <div class="container-footer-modal d-flex justify-content-center mt-xlg">
          <button
            (click)="onClose()"
            nz-button nzType="primary">
            ACEPTAR Y CERRAR
          </button>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #modalFooter>
  </ng-template>
</nz-modal>
